import React, { useEffect } from 'react';
import { ConfirmEmail } from './confirm-email/confirm-email';
import { VerifyAuthenticator } from './verify-authenticator/verify-authenticator';
import { Route, Switch } from 'react-router-dom';
import {
    RESET_PASSWORD_VERIFY_AUTHENTICATOR_PATH,
    RESET_PASSWORD_VERIFY_EMAIL_PATH,
    RESET_PASSWORD_VERIFY_PHONE_PATH,
    RESET_PASSWORD_CHANGE_PASSWORD_PATH,
    RESET_PASSWORD_PATH,
    ROTATE_CRED_PATH
} from '../../react-router-paths';
import { VerifyEmailSteps } from './verify-email-steps/verify-email-steps';
import { VerifyPhoneSteps } from './verify-phone-steps/verify-phone-steps';
import { ChangePassword } from './change-password/change-password';
import { useResetPasswordVerifyTotpMutation } from '../../slices/auth-api.slice';
import { RotateCred } from './rotate-cred';

export function VerifyContactRoutes() {
    const [, { data, reset }] = useResetPasswordVerifyTotpMutation({
        fixedCacheKey: 'resetPasswordVerifyTotp'
    });

    const contacts = data?.contacts || [];

    useEffect(() => {
        // we must reset the contacts data when this component is unmounted
        // this resets the mutation and removes the data
        return () => reset();
    }, [reset]);

    return (
        <>
            <Route path={RESET_PASSWORD_VERIFY_PHONE_PATH}>
                <VerifyPhoneSteps contacts={contacts} />
            </Route>
            <Route path={RESET_PASSWORD_VERIFY_EMAIL_PATH}>
                <VerifyEmailSteps contacts={contacts} />
            </Route>
        </>
    );
}

function renderSwitch() {
    // This function is a workaround because Switch does not support fragments directly
    // https://stackoverflow.com/a/67143069
    return (
        <>
            <Route exact path={RESET_PASSWORD_PATH}>
                <ConfirmEmail />
            </Route>
            <Route exact path={ROTATE_CRED_PATH}>
                <RotateCred />
            </Route>
            <Route path={RESET_PASSWORD_VERIFY_AUTHENTICATOR_PATH}>
                <VerifyAuthenticator />
            </Route>
            <VerifyContactRoutes />
            <Route path={RESET_PASSWORD_CHANGE_PASSWORD_PATH}>
                <ChangePassword />
            </Route>
        </>
    );
}

export function ResetPassword() {
    return <Switch>{renderSwitch()}</Switch>;
}
